module.exports = __webpack_public_path__ + "img/gsm.9e4e54d1.svg";